exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-info-price-wrapper,.product-reviews-summary,.product.attribute.overview,.product.media,product.attribute.additional-info{display:none}#canvasArea{padding-top:50px}.product-single{transform:translateZ(0)}.page-wrapper{overflow:visible!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3b4b4cb0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 39
// module chunks = 0